import { PickerLocale } from "antd/es/date-picker/generatePicker";
import CalendarLocale from 'rc-picker/lib/locale/vi_VN';

const vi_VN: PickerLocale = {
    lang: {
        ...CalendarLocale,
        locale: "vi_VN",
        placeholder: "Chọn ngày",
        rangePlaceholder: ["Ngày bắt đầu", "Ngày kết thúc"],
        today: "Hôm nay",
        now: "Bây giờ",
        backToToday: "Quay lại hôm nay",
        ok: "OK",
        clear: "Xóa",
        month: "Tháng",
        year: "Năm",
        timeSelect: "Chọn thời gian",
        dateSelect: "Chọn ngày",
        monthSelect: "Chọn tháng",
        yearSelect: "Chọn năm",
        decadeSelect: "Chọn thập kỷ",
        yearFormat: "YYYY",
        dateFormat: "D/M/YYYY",
        dayFormat: "D",
        dateTimeFormat: "HH:mm:ss D/M/YYYY ",
        monthFormat: "MMMM",
        monthBeforeYear: true,
        previousMonth: "Tháng trước",
        nextMonth: "Tháng sau",
        previousYear: "Năm trước",
        nextYear: "Năm tới",
        previousDecade: "Thập kỷ trước",
        nextDecade: "Thập kỷ tới",
        previousCentury: "Thế kỷ trước",
        nextCentury: "Thế kỷ tới",
        shortWeekDays: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"],
        shortMonths: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 6",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12"
        ]
    },
    timePickerLocale: {
        placeholder: "Chọn thời gian",
        rangePlaceholder: ["Thời gian bắt đầu", "Thời gian kết thúc"]
    },
    dateFormat: "DD-MM-YYYY",
    dateTimeFormat: "HH:mm:ss DD-MM-YYYY",
    weekFormat: "wo-YYYY",
    monthFormat: "MM-YYYY"

}
export default vi_VN;